export default {
  methods: {
    getPaymentLinks () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('paymentLink/getPaymentLinks', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getPaymentLinkTransactions () {
      this.isLoading = true
      this.payload.paymentLinkId = this.currentPaymentLinkId
      const vm = this
      this.$store
        .dispatch('paymentLink/getPaymentLinkTransactions', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
